module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name,
      "name": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "maxlength": "9",
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.renderedValue
    },
    on: {
      "input": _vm.input,
      "focus": _vm.focus,
      "blur": _vm.blur
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501c4a12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/SsnRender.vue
// module id = 1638
// module chunks = 1